import * as api from '@owl-nest/api-client/latest'

import type { ApiResponse } from '@owl-nest/api-client'

export async function createLink(url: string): Promise<ApiResponse<api.Link>> {
  const response = await api.api.post.link({
    body: { url },
  })

  return response.next((success) => success.body)
}
